var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRawGreenGreyBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.721,
    height: 100.721,
    viewBox: "0 0 100.721 100.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14081",
    "data-name": "Group 14081",
    transform: "translate(-509.48 -928.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13051",
    "data-name": "Group 13051",
    transform: "translate(509.48 928.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5374",
    "data-name": "Path 5374",
    d: "M50.36,0A50.36,50.36,0,1,1,0,50.36,50.36,50.36,0,0,1,50.36,0Z",
    transform: "translate(0 0)",
    fill: "#f5f7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13406",
    "data-name": "Group 13406",
    transform: "translate(512.524 946.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M200.142,777.133a17.908,17.908,0,0,0,.26-3.016,17.175,17.175,0,1,0-17.173,17.475,16.849,16.849,0,0,0,8.259-2.156,17.24,17.24,0,0,0,3.053-2.185l.468.358c2.314,1.775,4.636,3.581,7.111,5.129l.03.018a26.715,26.715,0,0,1-2.6,2.4,25.939,25.939,0,0,1-16.322,5.769,26.485,26.485,0,0,1-25.939-22.107,4.611,4.611,0,0,0,.669-.336l.013-.008a6.19,6.19,0,0,0,1.65-1.319,3.27,3.27,0,0,0,.677-2.44,4.688,4.688,0,0,0-.657-2.043,3.757,3.757,0,0,0-1.439-1.513c-.336-.176-.382-.3-.356-.608a1.893,1.893,0,0,0-.5-1.456l0,0a26.832,26.832,0,0,1,.7-2.859l1.733,1.417.349-.13A26.456,26.456,0,0,0,174.875,751.8l.112-.35-1.734-2.154a25.855,25.855,0,0,1,9.976-1.99,26.578,26.578,0,0,1,26.342,26.807,27.355,27.355,0,0,1-.657,5.975C205.861,779.228,202.9,778.194,200.142,777.133Z",
    transform: "translate(-145.246 -738.29)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M340.285,1092.946c-16.068-6.586-23.555.148-23.555.148,10.767-3.015,17.637,1.93,24.57,7.156,2.314,1.744,4.635,3.519,7.111,5.04a25.109,25.109,0,0,0,13.475,4.175c21.613.014,24.166-20.654,24.166-20.654-10.609,16.964-32.231,9.685-45.768,4.137h0Z",
    transform: "translate(-291.364 -1050.699)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M438.723,874.36s-2.489,2.4-3.061,3.036a1.866,1.866,0,0,0,0,2.749c1.916,2.091,2.46,2.863,2.374,3.694,0,0,2.838-2.548,3.238-2.892a1.555,1.555,0,0,0,.172-2.519,22.731,22.731,0,0,1-2.294-2.548,1.923,1.923,0,0,1-.43-1.518",
    transform: "translate(-399.968 -854.078)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M438.723,980.61s-2.489,2.4-3.061,3.035a1.866,1.866,0,0,0,0,2.749c1.916,2.091,2.46,2.864,2.374,3.694,0,0,2.838-2.548,3.238-2.892a1.556,1.556,0,0,0,.172-2.52,22.688,22.688,0,0,1-2.294-2.548,1.923,1.923,0,0,1-.43-1.517",
    transform: "translate(-399.968 -951.528)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M41.657,629.631c-.8.45-1.6.895-2.392,1.361-.836.492-1.658,1.009-2.491,1.506-.445.265-.9.51-1.357.76-.2.112-.422.2-.622.318-.379.227-.742.48-1.124.7-.6.351-1.225.674-1.828,1.027-1.129.663-2.249,1.341-3.375,2.008-.919.544-1.842,1.08-2.762,1.623-.346.2-.681.423-1.03.621-.607.345-1.23.661-1.825,1.025a2.013,2.013,0,0,0-.607.591c-.332.5-.619,1.033-.919,1.554-.708,1.228-1.409,2.461-2.119,3.69-.522.9-1.051,1.8-1.578,2.705-.538.919-1.087,1.831-1.613,2.756-.748,1.315-1.478,2.639-2.22,3.958-.15.267-.322.521-.479.785-.408.689-.821,1.377-1.216,2.074-.3.521-.567,1.055-.85,1.583l.064.07a1.354,1.354,0,0,0,.252-.09q1.1-.649,2.2-1.305c.755-.451,1.508-.9,2.26-1.357.542-.327,1.075-.671,1.624-.988a.61.61,0,0,1,.413-.06c.054.014.077.216.09.335.069.641.1,1.288.2,1.923a7.366,7.366,0,0,0,.4,1.564c.235.586.579,1.129.868,1.694a.518.518,0,0,1,.048.269c-.029.312-.1.622-.106.933a.919.919,0,0,0,.931,1.019,1.266,1.266,0,0,1,1.415.928,6.8,6.8,0,0,1,.539,1.812,7.523,7.523,0,0,1-.356,2.527c-.09.326-.031.408.289.3a6.468,6.468,0,0,0,1.365-.56,5.6,5.6,0,0,0,1.5-1.16,2.515,2.515,0,0,0,.529-1.919,3.908,3.908,0,0,0-.564-1.724,3.094,3.094,0,0,0-1.178-1.244,1.134,1.134,0,0,1-.712-1.24,1.174,1.174,0,0,0-1.237-1.284c-.7.027-1.229-.082-1.486-.809a11.7,11.7,0,0,1-.619-1.65,9.432,9.432,0,0,1-.077-1.939,3.492,3.492,0,0,1,.322-1.919.682.682,0,0,0,.044-.152,18.624,18.624,0,0,1,.7-2.1,20.183,20.183,0,0,1,1.257-2.2c.5-.808,1.025-1.606,1.578-2.38.658-.922,1.352-1.819,2.043-2.717a5.19,5.19,0,0,1,.523-.516l.123.085a1.856,1.856,0,0,1-.2.41c-.383.467-.814.9-1.169,1.383-.681.932-1.343,1.879-1.974,2.846a20.543,20.543,0,0,0-1.109,1.951c-.267.525-.471,1.084-.691,1.632q-.319.8-.611,1.6a1.776,1.776,0,0,0-.04.418,1.272,1.272,0,0,0,.269-.067l.328-.19.726-.419L31,648.81l.369-.646,6.362-11.138c.069-.114.137-.227.2-.341s.134-.241.2-.363l.007-.013.973-1.7c.193-.325.385-.65.573-.978.052-.091.1-.185.145-.28l.949-1.662c.368-.588.739-1.174,1.1-1.765a2.211,2.211,0,0,0,.139-.411,2.385,2.385,0,0,0-.364.121Z",
    transform: "translate(-11.25 -629.51)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M149.229,758.305l-9.259,5.718.18.267,3.985,3.2s10.717-3.908,14.347-15.028l-3.38-4.127-5.873,9.966Z",
    transform: "translate(-129.355 -738.54)",
    fill: "#21827f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRawGreenGreyBackground);
export default __webpack_public_path__ + "static/media/logo-raw-green-grey-background.d18643bf0f411b4f3f855eb5a61daf2d.svg";
export { ForwardRef as ReactComponent };